import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Bell, Check, Mail, AlertTriangle, FileText } from "lucide-react";
import { toast } from "sonner";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setItems((await api.get("/notifications")).data); }
    catch (err) { console.error("Notifications load failed:", err); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.post(`/notifications/${id}/read`); load(); }
    catch (err) { console.error("Mark read failed:", err); }
  };
  const markAll = async () => {
    try { await api.post("/notifications/mark-all-read"); toast.success("Tutte segnate come lette"); load(); }
    catch (err) { console.error("Mark all failed:", err); toast.error("Errore nel segnare le notifiche"); }
  };

  const iconFor = (t) => {
    if (t === "communication") return <FileText className="w-4 h-4"/>;
    if (t === "anomaly") return <AlertTriangle className="w-4 h-4"/>;
    return <Mail className="w-4 h-4"/>;
  };

  return (
    <div className="p-8 md:p-12 max-w-4xl" data-testid="notifications-page">
      <div className="flex items-start justify-between mb-8 gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest text-[#757575] mb-2">Centro</div>
          <h1 className="font-display text-4xl">Notifiche</h1>
          <p className="text-[#555] mt-1 text-sm">Tutte le comunicazioni e gli avvisi della tua azienda.</p>
        </div>
        <Button onClick={markAll} variant="outline" className="rounded-full" data-testid="mark-all-read-btn">
          <Check className="w-4 h-4 mr-2"/> Segna tutte lette
        </Button>
      </div>

      {loading ? <div className="text-[#757575]">Caricamento…</div> : items.length === 0 ? (
        <div className="card-smart p-12 text-center text-[#757575]" data-testid="no-notifications">
          <Bell className="w-12 h-12 mx-auto mb-3 text-[#3B82F6]/50"/>
          <div>Nessuna notifica.</div>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <div
              key={n.id}
              className={`border rounded-2xl p-4 flex items-start gap-3 cursor-pointer transition-colors ${n.read ? "bg-white border-[#1F2540]" : "bg-[#1E2347]/40 border-[#3B82F6]"}`}
              onClick={()=>!n.read && markRead(n.id)}
              data-testid={`notif-${n.id}`}
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${n.read ? "bg-[#1E2347] text-[#3B82F6]" : "bg-[#3B82F6] text-white"}`}>
                {iconFor(n.type)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold flex items-center gap-2">
                  {n.title}
                  {!n.read && <span className="w-2 h-2 rounded-full bg-[#3B82F6]"/>}
                </div>
                <div className="text-sm text-[#555] mt-0.5 truncate">{n.body}</div>
                <div className="text-[10px] text-[#999] mt-1 uppercase tracking-widest">{new Date(n.created_at).toLocaleString("it-IT")}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
